<template>
  <ModalBase v-if="showAgreement" modal-type="initial">
    <div slot="header">
      {{ $t("component.agreementModal.header") }}
    </div>
    <div slot="body">
      <div class="text-sm">
        {{ $t("component.agreementModal.salutation") }} {{ user.last_name }},
      </div>
      <div
        class="mt-4 overflow-x-auto border p-2 shadow-inner"
        style="height: 300px;"
      >
        <p class="text-sm">
          {{ $t("component.agreementModal.introduction") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.a") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.b") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.c") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.d") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.e") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.part.f") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.legal.a") }}
        </p>
        <p class="mt-4 text-sm">
          {{ $t("component.agreementModal.legal.b") }}
        </p>
        <div class="mt-4 text-sm">
          {{ $t("component.agreementModal.legal.c") }}
        </div>
      </div>
      <div class="mt-4 text-sm">
        <div class="font-bold">
          <input v-model="isAcceptingAgreement" type="checkbox" />
          {{ $t("component.agreementModal.accepting") }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="flex justify-end">
        <button
          class="border mt-5 p-2 pkss-btn primary"
          :class="[
            !isAcceptingAgreement ? 'opacity-50 cursor-not-allowed' : ''
          ]"
          :disabled="!isAcceptingAgreement"
          @click="acceptAgreement"
        >
          {{ $t("component.agreementModal.accept") }}
        </button>
      </div>
    </div>
  </ModalBase>
</template>

<script>
import ModalBase from "../shared/ModalBase";
import { mapState } from "vuex";
import UserService from "../../services/userOld.service";

export default {
  name: "AgreementModal",
  components: { ModalBase },
  data() {
    return {
      isAcceptingAgreement: false
    };
  },
  computed: {
    ...mapState("user", {
      user: "details"
    }),
    showAgreement() {
      let show = false;

      if (this.user !== null) {
        if (this.user?.employment_agreement_read !== null) {
          if (this.user?.employment_agreement_read === false) {
            show = true;
          }
        }
      }
      return show;
    }
  },
  methods: {
    async acceptAgreement() {
      await UserService.acceptEmploymentAgreement().then(async () => {
        await this.$store.dispatch("auth/user");
      });
    }
  }
};
</script>

<style scoped></style>
